import React from 'react';
import { usePluginActivationUTMQueryParamExtraction } from './utils';
import { getUtmParamsForChromeExtension } from '../Common/Utils/extensionSDK';
import { useQuery } from '../Common/Hooks';
import ITVLayout from '../ITVActivation/ITVLayout/ITVLayout';
import ITVActivation from '../ITVActivation';

interface AndroidInterface {
  navigateToSettings(): void;
  close(): void;
}

declare const KindredAndroid: AndroidInterface | undefined;

const PartnerPluginActivateV2: React.FC = () => {
  const query = useQuery();
  usePluginActivationUTMQueryParamExtraction(query);
  const utmParameters = getUtmParamsForChromeExtension();
  const utmSource = utmParameters.utmSource || query.get('utm_source');

  const isEmbeddedInAndroid = () => {
    return typeof KindredAndroid !== 'undefined';
  };

  const close = () => {
    if (typeof KindredAndroid !== 'undefined' && KindredAndroid.close) {
      KindredAndroid.close();
    }
  };

  const renderContent = () => {
    switch (utmSource) {
      case 'ITV':
        return (
          <ITVLayout
            onClose={close}
            isEmbeddedInAndroid={isEmbeddedInAndroid()}
          >
            <ITVActivation isEmbeddedInAndroid={isEmbeddedInAndroid()} />
          </ITVLayout>
        );

      default:
        return null;
    }
  };

  return renderContent();
};

export default PartnerPluginActivateV2;
